// src/data/apps.js
export const APPS = [
  {
    key: "appointments",
    slug: "appointments",
    name: "Appointments",
    blurb:
      "Programări online pentru frizerii & saloane: rezervare publică, sloturi inteligente, calendar personal, mesagerie, recenzii.",
    price: "De la 29 €/lună",
    image: "/appointments/cover.png",
    logo: "/appointments/logoappointments.png",
  },
  {
    slug: "presentation",
    image: "/presento/cover.svg", // shown as the card cover
    logo: "/presento/presentologo.svg", // small avatar in the card header
  },
  {
    slug: "testing",
    image: "/testing/cover.svg", // card cover
    logo: "/testing/logo.svg", // small avatar
  },
  {
    slug: "adminstarter",
    image: "/adminstarter/cover.svg",
    logo: "/adminstarter/logo.svg",
  },
  {
    slug: "management",
    image: "/management/cover.svg",
    logo: "/management/logo.svg",
  },
  {
    slug: "learning",
    image: "/learning/cover.svg",
    logo: "/learning/logo.svg",
  },
];
